import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'environmentPipe',
})
export class EnvironmentPipe implements PipeTransform {
  transform(env: string): string {
    switch (env) {
      case 'Dev':
        return 'Develop';
      case 'Ext01':
        return 'SR-Bank';
      case 'Ext02':
        return 'DNB Regnskap';
      case 'Prod':
        return 'Uni Economy';
      case 'Softrig01':
        return 'Østlandet';
      case 'Softrig02':
        return 'Sørøst-Norge';
      case 'Softrig03':
        return 'Nord-Norge';
      case 'Softrig04':
        return 'Hallingdal Valdres';
      case 'Softrig05':
        return 'Nordmøre';
      case 'Softrig06':
        return 'Østfold Akershus';
      case 'Softrig07':
        return 'Ringerike Hadeland';
      case 'Softrig08':
        return 'Telemark';
      case 'Softrig09':
        return 'Gudbrandsdal';
      case 'Softrig10':
        return 'Søre Sunnmøre';
      case 'Softrig11':
        return 'Lom og Skjåk';
      case 'Softrig12':
        return 'Modum';
      case 'Softrig13':
        return 'Helgeland';
      case 'Softrig19':
        return 'SMN';
      default:
        return env;
    }
  }
}
